import type { Dispatch, SetStateAction } from 'react';
import type { ReturnedPortfolio } from '../components/Create-Portfolio/types';
import axiosInstance from '../api/api';
import { API_ROUTES } from '../config/api-routes';
import { getSessionStore } from '../store/sessionStore';

export type PortfolioSectionField =
  | 'projects'
  | 'accomplishments'
  | 'certifications'
  | 'organizations';

export type PortfolioGetDataFn = (options?: {
  force?: boolean;
  silent?: boolean;
}) => void | Promise<void>;

export function applyPortfolioSnapshot(
  setPortfolioData: Dispatch<SetStateAction<ReturnedPortfolio>>,
  saved: Partial<ReturnedPortfolio> | null | undefined
) {
  if (!saved || typeof saved !== 'object') return;

  setPortfolioData((prev) => ({
    ...prev,
    overview: saved.overview ?? prev.overview,
    projects: saved.projects ?? prev.projects,
    references: saved.references ?? prev.references,
    languages: saved.languages ?? prev.languages,
    certifications: saved.certifications ?? prev.certifications,
    workCulture: saved.workCulture ?? prev.workCulture,
    accomplishments: saved.accomplishments ?? prev.accomplishments,
    organizations: saved.organizations ?? prev.organizations,
  }));
  getSessionStore().setPortfolio(saved);
}

export async function refreshPortfolioAfterSave(
  setPortfolioData: Dispatch<SetStateAction<ReturnedPortfolio>>,
  saved: Partial<ReturnedPortfolio> | null | undefined,
  getData?: PortfolioGetDataFn
) {
  applyPortfolioSnapshot(setPortfolioData, saved);
  if (getData) {
    await Promise.resolve(getData({ force: true, silent: true }));
  }
  await getSessionStore().refreshUser({ force: true });
  window.dispatchEvent(new Event('portfolio-updated'));
}

export async function persistPortfolioSection(
  portfolioId: number,
  field: PortfolioSectionField,
  items: ReturnedPortfolio[PortfolioSectionField],
  setPortfolioData: Dispatch<SetStateAction<ReturnedPortfolio>>,
  getData?: PortfolioGetDataFn
) {
  const response = await axiosInstance.post(
    `${API_ROUTES.PORTFOLIO.EDIT_PORTFOLIO}/${portfolioId}`,
    { [field]: items }
  );
  await refreshPortfolioAfterSave(setPortfolioData, response.data?.portfolio, getData);
}
